export default {
	setPortfolio: (state, data) => {
		state.portfolio = data
	},
	updatePortfolio: (state, portfolio) => {
		const copy = [...state.portfolio]
		const index = copy.findIndex(_portfolio => _portfolio.external_portfolio_id === portfolio.external_portfolio_id)
		copy[index] = portfolio
		state.portfolio = copy
	},
}
